/**
 * Viewport module types
 */
export const SET_VIEWPORT = 'SET_VIEWPORT';

/**
 * Scroll module types
 */
export const SET_SCROLL = 'SET_SCROLL';
export const LOCK_SCROLL = 'LOCK_SCROLL';

/**
 * Router module types
 */
export const SET_ROUTE_DATA = 'SET_ROUTE_DATA';
export const SET_PARTIALS_DATA = 'SET_PARTIALS_DATA';
export const SET_THEME = 'SET_THEME';
export const SET_COOKIE_CONSENT_DATA = 'SET_COOKIE_CONSENT_DATA';

/**
 * Overlay module types
 */
export const OPEN_OVERLAY = 'OPEN_OVERLAY';
export const CLOSE_OVERLAY = 'CLOSE_OVERLAY';

/**
 * Main-nav module types
 */
export const SET_NAVIGATION = 'SET_NAVIGATION';
export const RESET_NAVIGATION = 'RESET_NAVIGATION';
export const TOGGLE_MOBILE_NAVIGATION = 'TOGGLE_MOBILE_NAVIGATION';

/**
 * Section-nav module types
 */
export const UPDATE_SECTION = 'UPDATE_SECTION';
export const REMOVE_SECTION = 'REMOVE_SECTION';
export const SCROLL_TO_SECTION = 'SCROLL_TO_SECTION';
export const UPDATE_TITLE_SECTION = 'UPDATE_TITLE_SECTION';
export const REMOVE_TITLE_SECTION = 'REMOVE_TITLE_SECTION';

/**
 * Dropdown-filter module types
 */
export const SET_FILTER_DATA = 'SET_FILTER_DATA';
export const SET_FILTER_VALUE = 'SET_FILTER_OPITON';

/**
 * Form module types
 */
export const SET_FORM_FILTER = 'SET_FORM_FILTER';
export const SET_FORM_CONTROLLER = 'SET_FORM_CONTROLLER';



// WEBPACK FOOTER //
// ./sib-website/assets/src/js/app/vue/vuex/mutation-types.js